<template>
  <div class="review">
    <div class="review-start">
      <div class="review-user">
        <GFMP :styles="{ ...fmpStyles.circle, height: '32px', minWidth: '32px' }" />
        <div class="review-user-info">
          <GFMP :styles="{ ...fmpStyles.rounded, height: '16px', width: '56px' }" />
          <div class="review-user-beauty-profile">
            <div v-for="i in 2" :key="i" class="review-user-beauty-profile-inline">
              <GFMP v-for="_i in 2 + i" :key="_i" :styles="{ ...fmpStyles.rounded, height: '16px' }" />
            </div>
          </div>
        </div>
      </div>
      <div class="review-product">
        <GFMP :styles="{ ...fmpStyles.rounded, height: '56px', width: '56px' }" />
        <div class="review-product-content">
          <GFMP v-for="i in 2" :key="i" :styles="{ ...fmpStyles.rounded, width: `${30 + Math.random() * 70}%` }" />
          <div class="review-product-rating">
            <GFMP v-for="i in 5" :key="i" :styles="{ ...fmpStyles.circle, minWidth: '12px' }" />
          </div>
        </div>
      </div>
      <div class="review-detail">
        <div v-for="i in 2" :key="i" class="review-detail-content">
          <div v-for="_i in 2" :key="_i" class="review-detail-content-item">
            <GFMP v-for="__i in 2" :key="__i" :styles="{ ...fmpStyles.rounded, width: `calc(${__i} * 32px)` }" />
          </div>
        </div>
      </div>
      <div class="review-footer">
        <div v-for="i in 3" :key="i" class="review-footer-item">
          <GFMP v-for="_i in 2" :key="_i" :styles="{ ...fmpStyles.rounded, width: `calc(80% / ${_i})` }" />
        </div>
      </div>
    </div>
    <div class="review-end">
      <div class="review-user-level">
        <GFMP :styles="{ borderRadius: '12px', height: '24px', width: '136px' }" />
      </div>
      <div class="review-product-rating">
        <GFMP v-for="i in 5" :key="i" :styles="{ ...fmpStyles.rounded, height: '16px', minWidth: '16px' }" />
      </div>
      <div class="review-variant-description">
        <GFMP v-for="i in 5" :key="i" :styles="{ ...fmpStyles.rounded, width: `${30 + Math.random() * 70}%` }" />
      </div>
      <div class="review-variant-list">
        <div v-for="i in 3" :key="i" class="review-variant-card">
          <GFMP :styles="{ ...fmpStyles.rounded, height: '80px', width: '80px' }" />
          <div class="review-variant-card-content">
            <GFMP :styles="{ ...fmpStyles.circle, minWidth: '12px' }" />
            <GFMP :styles="{ ...fmpStyles.rounded, width: '32px' }" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'review-card-loader',
  data() {
    return {
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '12px',
        },
        circle: {
          borderRadius: '50%',
          height: '12px',
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

.review {
  display: flex;
  gap: 32px;
  padding: 16px;

  &-start {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 30%;
    .review {
      &-user {
        display: flex;
        gap: 8px;

        &-info {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          gap: 16px;
        }

        &-beauty-profile {
          display: flex;
          flex-direction: column;
          gap: 4px;

          &-inline {
            display: flex;
            gap: 8px;

            & div {
              flex-grow: 1;
            }
          }
        }
      }

      &-product {
        display: flex;
        gap: 24px;
        padding: 8px 16px;

        &-content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex-grow: 1;
        }

        &-rating {
          display: flex;
          gap: 4px;
        }
      }

      &-detail {
        display: flex;
        gap: 32px;

        &-content {
          display: flex;
          flex-direction: column;
          gap: 16px;

          &-item {
            display: flex;
            gap: 8px;
          }
        }
      }

      &-footer {
        display: flex;

        &-item {
          flex-grow: 1;
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
      }
    }
  }

  &-end {
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex-grow: 1;

    .review {
      &-user-level {
        display: flex;
        justify-content: end;
      }

      &-product-rating {
        display: flex;
        gap: 8px;
      }

      &-variant {
        &-description {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        &-list {
          display: flex;
          gap: 8px;
        }

        &-card {
          display: flex;
          flex-direction: column;
          gap: 24px;

          &-content {
            display: flex;
            gap: 4px;
          }
        }
      }
    }
  }
}
</style>
